module.exports = __webpack_public_path__ + "media/Video 23.82434114.mp4";